import {
	documentToReactComponents,
	Options,
} from '@contentful/rich-text-react-renderer';
import { BLOCKS } from '@contentful/rich-text-types';
import { Block } from '../../factories/types';
import { ButtonWrapper } from '../button/ButtonWrapper';
import styles from './ColumnsItem.module.scss';

export const ColumnsItem: Block<'item'> = ({
	data: {
		fields: { title, text, button },
	},
	fieldId,
}) => {
	return (
		<div className={styles.columnsItem}>
			{title && (
				<div className={styles.title} {...fieldId('title')}>
					{documentToReactComponents(title, textRenderOptions)}
				</div>
			)}

			{text && (
				<div className={styles.text} {...fieldId('text')}>
					{documentToReactComponents(text, textRenderOptions)}
				</div>
			)}

			{button && (
				<div className={styles.buttonsWrapper} {...fieldId('button')}>
					<ButtonWrapper
						key={button.sys.id}
						data={button}
						isPrimary = {true}
					/>
				</div>
			)}
		</div>
	);
};

const textRenderOptions: Options = {
	preserveWhitespace: true,
	renderNode: {
		/**
		 * TODO(amatlash): move to utils
		 * NOTE(amatlash): this one fixes empty paragraphs that are sometimes added after completely deleting the content of the field.
		 */
		[BLOCKS.PARAGRAPH]: (_, children) => {
			if (Array.isArray(children) && children.length === 1) {
				if (!children[0]) return null;
			}

			return <p>{children}</p>;
		},
	},
};
